export default "__VITE_ASSET__d0f14c70__"